import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const GridContainer = styled.div`
	display: grid;
	grid-template-columns: 32.8% 32.9% 32.8%;
	gap: 10px;
	background-color: ${colors.grey1};
	padding: 0.5%;
`;
